import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=10fd8eb5&scoped=true&"
import script from "./TaskOverview.vue?vue&type=script&lang=js&"
export * from "./TaskOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd8eb5",
  null
  
)

export default component.exports